<template>
  <BaseSideDetail v-model="openDriverDetailDialog">
    <template #title>
      <div style="width: 100%" v-if="driverDetail">
        <div class="d-flex justify-space-between" style="width: 100%">
          <h5 class="card-header-title text-uppercase white--text">
            <BaseTooltip
              title="Order reference number"
              v-if="driverDetail.full_name"
              :text="driverDetail.full_name"
            />
          </h5>
          <h5 class="card-header-title text-uppercase white--text">
            <BaseTooltip
              title="Order Status"
              v-if="driverDetail.status"
              :text="driverDetail.status"
            />
          </h5>
        </div>
        <div class="d-flex justify-space-between py-1" style="width: 100%">
          <v-row no-gutters class="text-right">
            <v-col cols="6" class="text-left">
              <h5 class="card-header-title">
                <BaseTooltip
                  v-if="driverDetail.branch"
                  title="Branch Name"
                  :text="driverDetail.branch"
                />
              </h5>
            </v-col>
            <v-col cols="6" class="text-right">
              <h5 class="card-header-title">
                <BaseTooltip
                  v-if="driverDetail.vehicle_assigned"
                  title="Assigned Vehicle"
                  :text="driverDetail.vehicle_assigned"
                />
              </h5>
            </v-col>
          </v-row>
        </div>
      </div>
    </template>
    <template #action>
      <v-row>
        <v-col cols="6" class="text-left">
          <v-btn small depressed @click="getDriverDetail(id)">
            <v-icon small>mdi-refresh</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="6" class="text-right">
          <v-btn
            id="driversEdit"
            v-if="driverDetail && driverDetail.id"
            small
            depressed
            :to="`/app/client/driver/edit/${driverDetail.id}`"
          >
            Edit
          </v-btn>
        </v-col>
      </v-row>
    </template>
    <template #content>
      <div v-if="driverDetail" class="px-4">
        <BaseCard
          v-if="driverDetail"
          title="Driver Information"
          status="unassigned"
          :data="driverDetail"
        />
      </div>
    </template>
  </BaseSideDetail>
</template>

<script>
import { bus } from "@/main.js";
import BaseSideDetail from "@/components/BaseComponents/BaseSideDetail.vue";
import BaseTooltip from "@/components/BaseComponents/BaseTooltip.vue";
import BaseCard from "@/components/BaseComponents/BaseCard.vue";

export default {
  props: {
    value: Boolean,
    id: {
      required: true,
    },
  },
  components: {
    BaseSideDetail,
    BaseTooltip,
    BaseCard,
  },
  data() {
    return {
      drawer: false,
      driverDetail: null,
    };
  },
  watch: {
    openDriverDetailDialog(val) {
      if (val) {
        this.getDriverDetail(this.id);
      }
    },
    id() {
      this.getDriverDetail(this.id);
    },
  },
  computed: {
    openDriverDetailDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    getDriverDetail(id) {
      bus.$emit("showLoader", true);
      this.$api.driver
        .getDriverView(id)
        .then((res) => {
          this.driverDetail = res.data;
          console.log(this.driverDetail);
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>

<style scoped lang="scss">
@mixin headerFont {
  font-family: "Roboto", sans-serif !important;
  font-size: 0.85rem;
  font-weight: 500;
  line-height: 1.5rem;
  letter-spacing: 0.03125em;
  color: white;
}

.card-header-title {
  @include headerFont;
}

@media screen and (max-width: 1280px) {
  .card-header-title {
    @include headerFont;
    font-size: 0.75rem;
    line-height: 1.25rem;
    letter-spacing: 0.0333333333em;
  }
}
</style>